import { render, staticRenderFns } from "./workPopup.vue?vue&type=template&id=768eda03&scoped=true&"
import script from "./workPopup.vue?vue&type=script&lang=js&"
export * from "./workPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "768eda03",
  null
  
)

export default component.exports